import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import IndexPage from 'flarum/forum/components/IndexPage';
import SocialGroupsList from './components/SocialGroupsList';
import GroupDetailPage from './components/GroupDetailPage';
import GroupsPage from './components/GroupsPage';
import RegisterWidget from '../common/registerWidget';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';

app.initializers.add('tf-groups-forum', () => {
  // 添加群组列表页面路由
  app.routes.groups = { path: '/groups', component: GroupsPage };
  
  // 添加群组详情页面路由
  app.routes.groupDetail = { path: '/groups/:id', component: GroupDetailPage };

  // 注册User Groups Widget
  RegisterWidget();

  // 在首页添加群组列表
  // extend(IndexPage.prototype, 'sidebarItems', function (items) {
  //   items.add('social-groups-list', <SocialGroupsList />, 10);
  // });

  // Extend DiscussionListItem to show group info
  // 暂时注释掉这个扩展，因为它可能与Flarum核心组件的key使用产生冲突
  // extend(DiscussionListItem.prototype, 'view', function (vdom) {
  //   const discussion = this.attrs.discussion;
  //   
  //   // 直接从discussion中获取注入的群组信息
  //   const group = discussion.attribute && discussion.attribute('social_group');
  //   
  //   if (group) {
  //     // 确保vdom.children存在且为数组
  //     if (!vdom.children) {
  //       vdom.children = [];
  //     }
  //     
  //     vdom.children.unshift(
  //       <div className="DiscussionListItem-group" key="social-group-info">
  //         <a href={`/g/${group.slug}`}>
  //           {group.cover_image ? <img src={app.forum.attribute('baseUrl') + '/' + group.cover_image} className="Group-thumbnail" /> : null}
  //           <span className="Group-name">{group.name}</span>
  //         </a>
  //       </div>
  //     );
  //   }
  //   
  //   return vdom;
  // });

  // Extend DiscussionHero to show group breadcrumb navigation
  extend(DiscussionHero.prototype, 'view', function (vdom) {
    const discussion = this.attrs.discussion;
    
    // 直接从discussion中获取注入的群组信息
    const group = discussion.attribute && discussion.attribute('social_group');
    
    if (group) {
      
      // 创建面包屑导航
      const breadcrumb = (
        <div className="newtopic-Breadcrumb">
          <div className="breadcrumb-Component">
            <a href="/" onclick={(e) => { e.preventDefault(); m.route.set('/'); }}>
              <img src="/images/home.png" className="home" />
            </a>
            <a href="/" className="home-span" onclick={(e) => { e.preventDefault(); m.route.set('/'); }}>
              Community
            </a>
            <a 
              href="#" 
              className="params-span"
              onclick={(e) => { 
                e.preventDefault(); 
                m.route.set(app.route('groupDetail', { id: group.id })); 
              }}
            >
              〉{group.name}
            </a>
            <a href="#" className="params-span">
              〉{discussion.title()}
            </a>
          </div>
        </div>
      );
      
      // 替换DiscussionHero的内容，只显示面包屑导航
      if (vdom.children && vdom.children[0]) {
        const container = vdom.children[0];
        // 清空原有内容
        container.children = [];
        // 只添加面包屑导航，确保有key
        container.children.push(breadcrumb);
      }
    }
    
    return vdom;
  });
  // 提交时强制只使用一个标签（群组），与 DiscussionComposer-changeTags 一致
  extend(DiscussionComposer.prototype, 'onsubmit', function (original, e) {
    const tags = this.composer.fields.tags || [];
    if (tags.length > 1) {
      this.composer.fields.tags = [tags[0]];
    }
    return original(e);
  });
});